import { render, staticRenderFns } from "./SecondaryTabsButton.vue?vue&type=template&id=bbac6c44&scoped=true&"
import script from "./SecondaryTabsButton.vue?vue&type=script&lang=js&"
export * from "./SecondaryTabsButton.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryTabsButton.vue?vue&type=style&index=0&id=bbac6c44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbac6c44",
  null
  
)

export default component.exports